<div *ngIf="entities$ | async as entities" class="user-edit-container">
    <header>
        <a class="back-button href-btn" *ngIf="!isModal" (click)="cancel()">&lt; Back</a>
        <h1 mat-dialog-title>Edit Staff</h1>
        <a class="mobile-cancel-button" fxHide.gt-sm *ngIf="!isModal" (click)="cancel()">Cancel</a>
    </header>
    <form [formGroup]="userForm" *ngIf="user$ | async as user" (ngSubmit)="saveUser(user)">
        <div mat-dialog-content>
            <div class="user-info">
                <div class="user-contact-info">
                    <h2>Contact Info</h2>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.firstName as field">
                            <mat-label>First Name</mat-label>
                            <input
                                matInput
                                id="firstName"
                                type="text"
                                placeholder="First Name"
                                formControlName="firstName"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.lastName as field">
                            <mat-label>Last Name</mat-label>
                            <input
                                matInput
                                id="lastName"
                                type="text"
                                placeholder="Last Name"
                                formControlName="lastName"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.email as field">
                            <mat-label>Email</mat-label>
                            <input
                                matInput
                                id="email"
                                type="email"
                                lowercase-inp
                                placeholder="Email"
                                formControlName="email"
                                required
                                [errorStateMatcher]="errorMatcher"
                            />
                            <mat-hint>Cannot be changed after the user login is created</mat-hint>
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <button mat-stroked-button type="button" (click)="resendInvite(user)" *ngIf="!user.gitkitId">Resend Invite</button>
                </div>
                <div class="user-company-info">
                    <h2>Company Info</h2>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.entityId as field">
                            <mat-label>Company</mat-label>
                            <select matNativeControl id="entityId" formControlName="entityId" required [errorStateMatcher]="errorMatcher">
                                <option value="" [selected]="!user.entityId">Select a company</option>
                                <option *ngFor="let entity of entities$ | async; trackBy: trackById" [value]="entity.id">
                                    {{ entity.name }}
                                </option>
                            </select>
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" *letVar="fields.roleId as field">
                            <mat-label>User Type</mat-label>
                            <select
                                *letVar="userRoles$ | async as roles"
                                matNativeControl
                                id="roleId"
                                formControlName="roleId"
                                required
                                [errorStateMatcher]="errorMatcher"
                            >
                                <option value="" [selected]="!user.roleId">Select a user type</option>
                                <option *ngFor="let role of roles; trackById" [value]="role.id">{{ role.name }}</option>
                            </select>
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>
            </div>
        </div>
        <mat-card-actions class="formActionButtonGroup clearfix">
            <button mat-raised-button id="submitButton" color="primary" class="new-primary-button" type="submit">Save</button>
            <a mat-button *ngIf="!data || !data.customer" color="warn" (click)="deleteUser(user)" id="deleteButton"> Delete </a>
        </mat-card-actions>
    </form>
</div>
